import { sortDescDataByLabel, sortDescDataByLabelRanges } from '../../../../utils/harvestData';
import { ApplicationStats, LabelColor, YieldRegionReport } from '../../../../types';
import { ApplicationStatsLabel } from '../RegionReportItemsRow/ApplicationStatsLabel';
import { ColorStatsLabel } from '../RegionReportItemsRow/ColorStatsLabel';
import { YieldReportStatsLabel } from '../RegionReportItemsRow/YieldReportStatsLabel';
import type { SetItemCallback } from '../container/useRegionReportController';

export type RegionReportItemsProps = {
  allowHover?: boolean;
  colors?: LabelColor;
  data?: ApplicationStats[] | YieldRegionReport[];
  dataTestId: string;
  locale: string;
  onClickItem?: SetItemCallback;
  showIcon?: boolean;
  index: number;
  displayRanges: boolean;
  cropCode: string;
  cropNominalWeight?: number | null;
};

function isApplicationStats(item: ApplicationStats) {
  return Object.prototype.hasOwnProperty.call(item, 'dateApplied');
}

type ReportingItems =  (ApplicationStats | YieldRegionReport)[];

export const RegionReportItems = ({
  colors = [],
  data = [],
  dataTestId,
  index,
  locale,
  onClickItem,
  displayRanges,
  cropCode,
  cropNominalWeight
}: RegionReportItemsProps) => {
  const unsortedData = (data ?? []) as ReportingItems;

  let sortedData: ReportingItems;
  if (displayRanges) {
    sortedData = unsortedData.sort(sortDescDataByLabelRanges);
  } else {
    sortedData = unsortedData.sort(sortDescDataByLabel);
  }
  
  return (
    <>
      {sortedData.map((item) => {
        if (isApplicationStats(item as ApplicationStats)) {
          return <ApplicationStatsLabel
            dataTestId={dataTestId}
            index={index}
            item={item as ApplicationStats}
            locale={locale}
            key={`application-stats-${dataTestId}-${item.label}`}
            cropCode={cropCode}
            cropNominalWeight={cropNominalWeight ?? undefined}
          />
        }
        if (colors?.length > 0) {
          return <ColorStatsLabel
            colors={colors}
            dataTestId={dataTestId}
            index={index}
            item={item as YieldRegionReport}
            onClickItem={onClickItem}
            key={`color-stats-${dataTestId}-${item.label}`}
            cropCode={cropCode}
            cropNominalWeight={cropNominalWeight ?? undefined}
          />
        }

        return <YieldReportStatsLabel
          dataTestId={dataTestId}
          index={index}
          item={item as YieldRegionReport}
          onClickItem={onClickItem}
          key={`yield-stats-${dataTestId}-${item.label}`}
          cropCode={cropCode}
          cropNominalWeight={cropNominalWeight ?? undefined}
          isArdData={false}
        />
      })}
    </>
  );
};